import axios from "axios";
import store from "../store";

export const $API_GATEWAY_MULEEX = process.env.VUE_APP_MULEEX_CORE_ENDPOINT;

export const $API_GATEWAY_QUANTUM = process.env.VUE_APP_QUANTUM_ENDPOINT;

export const $API_GATEWAY_MESSAGING = process.env.VUE_APP_GLOBAL_MESSAGING;

export const $API_MULEEX_MONO = process.env.VUE_APP_MULEEX_MONO;

export const $API_GATEWAY_BOOKINGS = process.env.VUE_APP_BOOKING_ENGINE;
// const $API_GATEWAY_BOOKINGS = process.env.VUE_APP_BOOKING_ENGINE;

export const $API_GATEWAY_UPLOAD = process.env.VUE_APP_DOCUMENT_UPLOAD

export const $API_GATEWAY_TRIPS = process.env.VUE_APP_TRIP_ENDPOINT

export const $API_GATEWAY_NOTIFICATION = process.env.VUE_APP_NOTIFICATION

export const $GOOGLE_KEY = process.env.VUE_APP_NOTIFICATION

let $authHeader = {
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: "Bearer " + localStorage.getItem("token"),
};

let $authHeaderQuantum = {
  Accept: "application/json",
  authorization: localStorage.getItem("quantumToken"),
};

export const AxiosMULEEX = axios.create({
  baseURL: $API_GATEWAY_MULEEX,
  headers: $authHeader,
});

export const AxiosQUANTUM = axios.create({
  baseURL: $API_GATEWAY_QUANTUM,
  headers: $authHeaderQuantum,
});

export const AxiosMono = axios.create({
  baseURL: $API_MULEEX_MONO,
  headers: $authHeader,
});

export const AxiosBookings = axios.create({
  baseURL: $API_GATEWAY_BOOKINGS,
  headers: $authHeader,
});

export const AxiosGLobalMessaging = axios.create({
  baseURL: $API_GATEWAY_MESSAGING,
  headers: $authHeader,
});

export const TripEndpoint = axios.create({
  baseURL: $API_GATEWAY_TRIPS,
});

export const AxiosNotification = axios.create({
  baseURL: $API_GATEWAY_NOTIFICATION,
  headers: $authHeader,
});


AxiosMULEEX.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});



AxiosQUANTUM.interceptors.request.use((config) => {
  if (
    store.state.authentication.token != null ||
    store.state.authentication.token != ""
  ) {
    config.headers.authorization = store.state.authentication.quantumToken;
  }
  return config;
});

AxiosBookings.interceptors.request.use((config) => {
  if (
    store.state.authentication.tokens != null ||
    store.state.authentication.token != ""
  ) {
    config.headers.Authorization = `Bearer ${store.state.authentication.token}`;
  }
  return config;
});

AxiosNotification.interceptors.request.use((config) => {
  if (
    store.state.authentication.tokens != null ||
    store.state.authentication.token != ""
  ) {
    config.headers.Authorization = `Bearer ${store.state.authentication.token}`;
  }
  return config;
});

export const orgId = () => store.state.authentication.organizationId;
export const userId = () => store.state.authentication.userId;
export const quantumUserId = () => store.state.authentication.quantumUserId;
export const quantumOrgId = () =>
  store.state.authentication.quantumOrganizationId;
